import { render } from "./Layout.vue?vue&type=template&id=e766a2b0&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=e766a2b0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e766a2b0"

export default script